<!-- Acciones y cuerpo salen de plantillas para no duplicar el markup entre los
     dos modos: con tarjeta (solapa del detalle, necesita su propio título) y
     embebido (diálogo, donde el título ya lo pone el header del diálogo y otra
     tarjeta adentro deja bordes y sombras encimadas). -->
<ng-template #acciones>
  <div class="fila-ns-acciones">
    <button
      irxBoton="secundario"
      (click)="cargar()"
      [disabled]="cargando || flusheando"
      tooltip="Volver a consultar la fila en Chirpstack"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
    <button
      irxBoton="peligro"
      (click)="flush()"
      [disabled]="!hayItems || cargando || flusheando"
      tooltip="Borra TODA la fila pendiente del dispositivo en el network server"
    >
      <mat-icon>delete_sweep</mat-icon>
      Vaciar la fila
    </button>
  </div>
</ng-template>

<ng-template #cuerpo>
  <div class="card-body">
    @if (cargando && !fila) {
      <div class="fila-ns-cargando">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    } @else if (!fila) {
      <div class="fila-ns-vacio fila-ns-error">
        <mat-icon>error_outline</mat-icon>
        No se pudo leer la fila del network server. Probá de nuevo con
        «Actualizar».
      </div>
    } @else {
      <div class="chips-dato-grid">
        <app-chip-dato
          label="Downlinks en fila"
          [valor]="fila.totalItems"
          icon="playlist_add"
          [color]="hayItems ? 'naranja' : 'verde'"
          [hint]="
            hayItems
              ? 'Esperando que el nodo abra una ventana de recepción'
              : 'El network server no tiene nada pendiente'
          "
        />
        <app-chip-dato
          label="Vencidos"
          [valor]="fila.itemsVencidos"
          icon="timer_off"
          [color]="fila.itemsVencidos ? 'rojo' : 'gris'"
          hint="Pasó su expiresAt: ya no tiene sentido entregarlos"
        />
        <app-chip-dato
          label="Sin vencimiento"
          [valor]="fila.itemsSinVencimiento"
          icon="do_not_disturb_on"
          [color]="fila.itemsSinVencimiento ? 'rojo' : 'gris'"
          hint="No tienen expiresAt: el network server no los descarta nunca por su cuenta"
        />
        <app-chip-dato
          label="Vigentes"
          [valor]="itemsVigentes"
          icon="schedule_send"
          [color]="itemsVigentes ? 'naranja' : 'gris'"
          hint="Dentro de su plazo: si el nodo habla, se entregan"
        />
        <app-chip-dato
          label="Clase del dispositivo"
          [valor]="fila.claseBC ? 'B/C' : 'A'"
          icon="settings_input_antenna"
          [color]="fila.claseBC ? 'violeta' : 'teal'"
          [hint]="
            fila.claseBC
              ? 'El scheduler del NS agenda contra él aunque no tenga ruta'
              : 'Sólo recibe en la ventana RX de un uplink'
          "
        />
        <app-chip-dato
          label="Comunicación"
          [valor]="fila.offline ? 'Sin comunicación' : 'Con comunicación'"
          icon="cell_tower"
          [color]="fila.offline ? 'rojo' : 'verde'"
          [hint]="fila.motivoOffline || 'Dentro de su tiempo límite'"
        />
      </div>

      @if (esFilaHuerfana) {
        <!-- Las dos condiciones del bucle, juntas: clase B/C + sin ruta de
             downlink. Es el caso que hace fallar al scheduler en cada tick. -->
        <div class="fila-ns-alerta">
          <mat-icon>warning</mat-icon>
          <div>
            <b>Fila huérfana.</b>
            El dispositivo es clase B/C y está sin comunicación, así que no tiene ruta de
            downlink: el scheduler del network server falla al elegirle gateway
            <i>antes</i>
            de mirarle el vencimiento, con lo cual estos items no se entregan,
            no vencen y no se borran solos. Además, si el dispositivo volviera a
            comunicar, los recibiría todos juntos y pegados.
            @if (todosDescartables) {
              <span>
                Ninguno tiene valor ya (vencidos o sin vencimiento): vaciar la
                fila no pierde nada.
              </span>
            }
          </div>
        </div>
      }

      @if (hayItems) {
        <div class="fila-ns-tabla-wrap">
          <table class="fila-ns-tabla">
            <thead>
              <tr>
                <th>#</th>
                <th>Puerto</th>
                <th>Payload (hex)</th>
                <th>Confirmado</th>
                <th>FCnt down</th>
                <th>Vence</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              @for (item of fila.items; track item.id || $index) {
                <tr [class.vencido]="item.vencido">
                  <td>{{ $index + 1 }}</td>
                  <td>
                    @if (item.fPort != null) {
                      {{ item.fPort }}
                    } @else {
                      <span class="no-info">Sin puerto</span>
                    }
                  </td>
                  <td class="mono">
                    @if (item.payloadHex) {
                      {{ item.payloadHex }}
                    } @else {
                      <span class="no-info">Sin payload</span>
                    }
                  </td>
                  <td>{{ item.confirmed ? 'Sí' : 'No' }}</td>
                  <td>
                    @if (item.fCntDown != null) {
                      {{ item.fCntDown }}
                    } @else {
                      <span class="no-info">Sin fCnt</span>
                    }
                  </td>
                  <td>
                    @if (item.expiresAt) {
                      {{ formatearFecha(item.expiresAt) }}
                    } @else {
                      <span class="no-info">Sin vencimiento</span>
                    }
                  </td>
                  <td>
                    @if (item.vencido) {
                      <span class="badge badge-rojo">Vencido</span>
                    } @else if (item.sinVencimiento) {
                      <span
                        class="badge badge-rojo"
                        matTooltip="Sin expiresAt: el network server no lo va a descartar nunca por su cuenta"
                      >
                        Sin vencimiento
                      </span>
                    } @else if (item.isPending) {
                      <span class="badge badge-amarillo">Esperando ACK</span>
                    } @else {
                      <span class="badge badge-verde">Vigente</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="fila-ns-vacio">
          <mat-icon>check_circle</mat-icon>
          La fila está vacía: el network server no tiene nada pendiente para
          este dispositivo.
        </div>
      }
    }
  </div>
</ng-template>

<div class="fila-ns" [class.fila-ns-embebido]="!enTarjeta">
  @if (enTarjeta) {
    <app-content-card
      title="Fila de downlinks en el network server"
      subtitle="Lo que Chirpstack tiene pendiente de entregarle a este dispositivo"
      icon="playlist_remove"
      color="indigo"
    >
      <div card-header-actions>
        <ng-container [ngTemplateOutlet]="acciones"></ng-container>
      </div>
      <ng-container [ngTemplateOutlet]="cuerpo"></ng-container>
    </app-content-card>
  } @else {
    <ng-container [ngTemplateOutlet]="acciones"></ng-container>
    <ng-container [ngTemplateOutlet]="cuerpo"></ng-container>
  }
</div>
